<template>
  <div class="edit-module-variant">
    <v-skeleton-loader v-if="loading" type="heading, image" class="ma-3" />

    <v-alert v-else-if="loadError" type="error" text class="ma-3">
      {{ loadError }}
    </v-alert>

    <v-form v-else ref="form" v-model="valid" lazy-validation>
      <v-container fluid class="pa-2 pa-sm-3">
        <v-alert type="info" text dense>
          Cette configuration remplace les paramètres par défaut du module pour l’entreprise sélectionnée.
        </v-alert>

        <v-card outlined>
          <component
            v-if="adminComponent"
            :is="adminComponent"
            :module="module"
            :modalKey="editorContextKey"
            :page="null"
            :itemTableListe="itemTableListe"
            :buildingParameters="dependencies.listParameters"
            @recepVal="updateDisplays"
          />

          <v-alert v-else type="error" text class="ma-3">
            Le composant d’administration du module « {{ module.type }} » est introuvable.
          </v-alert>
        </v-card>

        <div class="d-flex justify-end mt-3">
          <v-btn color="primary" :disabled="!valid || saving" :loading="saving" @click="validate">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer la variante
          </v-btn>
        </div>
      </v-container>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'EditModuleVariant',

  props: {
    moduleId: { type: [String, Number], required: true },
    variant: { type: [String, Number], required: true },
    contextKey: { type: String, default: '' },
    embedded: { type: Boolean, default: false },
    standalone: { type: Boolean, default: false },
  },

  data() {
    return {
      module: null,
      dependencies: { listParameters: {}, listTables: [] },
      itemTableListe: [],
      internalContextKey: `edit-module-variant-${this._uid}`,
      valid: true,
      loading: true,
      saving: false,
      loadError: '',
    }
  },

  computed: {
    editorContextKey() {
      return this.contextKey || this.internalContextKey
    },

    adminComponent() {
      const plugin = this.module && this.module.type ? this.$modules[this.module.type] : null
      return plugin && plugin.components ? plugin.components.admin : null
    },
  },

  methods: {
    clone(value) {
      return JSON.parse(JSON.stringify(value))
    },

    async loadInitialData() {
      this.loading = true
      this.loadError = ''
      try {
        const response = await this.API({
          type: 'post',
          url: 'engine/module/edit',
          params: { filter: { id: this.moduleId, variant: this.variant } },
        })
        this.module = this.clone(response.data.module)
        this.dependencies = response.data.dependencies || { listParameters: {}, listTables: [] }
        this.itemTableListe = (this.dependencies.listTables || []).map(table => ({ text: table, value: table }))
      } catch (error) {
        this.loadError = 'Impossible de charger cette variante du module.'
      } finally {
        this.loading = false
      }
    },

    updateDisplays(displays) {
      this.$set(this.module, 'displays', displays)
    },

    async validate() {
      if (!this.$refs.form.validate()) return

      this.saving = true
      this.$store.dispatch('getoverlay', true)
      try {
        const response = await this.API({
          type: 'put',
          url: 'engine/module/editvariant',
          params: { id: this.moduleId, displays: this.module.displays, variant: this.variant },
        })
        this.module = this.clone(response.data.module)
        this.$emit('saved', this.module)
      } finally {
        this.saving = false
        this.$store.dispatch('getoverlay', false)
      }
    },
  },

  mounted() {
    this.loadInitialData()
  },
}
</script>

<style scoped>
.edit-module-variant {
  width: 100%;
}
</style>
